import { Metadata } from "./Metadata";
import { AxiosError } from "axios";

export type NoContentApiResponse = null;
export type CreatedApiResponse = ApiResponse<{ id: number }>;

export type ForbiddenApiResponse = {
  code: string | null;
  message: string;
  data?: Record<string, any> | null;
};

export type BadRequestApiResponse = {
  code: string | null;
  message: string;
};

export type ValidationApiResponse = {
  message: string;
  errors: {
    [field: string]: string[];
  };
};

export type MessageApiResponse = {
  message: string;
};

export interface ApiResponse<T> {
  data: T;
  meta?: Metadata;
  error?: any;
}

export interface PaginationApiResponse<T> extends ApiResponse<T> {
  data: T;
  meta: Metadata;
}

export interface ApiErrorIf {
  message: string;
  errors: Record<string, string[]>;
}

export const isForbiddenApiError = (
  error: AxiosError,
): error is AxiosError<ForbiddenApiResponse> => {
  return error.status === 403;
};

export function isValidationApiError(
  error: AxiosError,
): error is AxiosError<ValidationApiResponse> {
  return error.response?.status === 422;
}

export function isBadRequestApiError(
  error: AxiosError,
): error is AxiosError<BadRequestApiResponse> {
  return error.response?.status === 400;
}
